<template>
	<div class="sdk_initaial">
		<document-title-bar :pathData="isPathData"></document-title-bar>
		<h1 class="doc_main_h1">获取全部终端</h1>
		<h3 class="doc_main_h3">功能描述</h3>
		<p class="doc_main_p">
			terminal_list接口提供了获取终端组下全部终端列表的功能。
		</p>
		<h3 class="doc_main_h3">调用URL</h3>
		<pre class="doc_main_pre"><code class="doc_main_code"><a href="https://skfrm.cn/APIV2/terminal_list">https://skfrm.cn/APIV2/terminal_list</a></code></pre>		
        <h3 class="doc_main_h3">请求参数</h3>
		<frm-Request-parameters :propsTableData="frmRequestParams"></frm-Request-parameters>
        <h3 class="doc_main_h3">返回值说明</h3>
		<frm-Return-Value-New :propsTableData='frmReturnValueNew'></frm-Return-Value-New>
		<!-- <h3 class="doc_main_h3">通用错误码</h3>
		<frm-Error-Code :propsTableData='frmErrorCode'></frm-Error-Code> -->
		<h3 class="doc_main_h3">返回值示例</h3>
		<pre class="doc_main_pre"><code class="doc_main_code">成功：
	{
		"error_code":"0",
		"error_msg":"success",
		"data":
		[
			{
				"terminal_id":"260",
				"terminal_name":"ipad",
				"ability":"1",
				"platform":"iOS11.3.1",
				"visual_image":"./Uploads/visual/2018-10-10/1539138526765.jpg","last_time":"1539138527",
				"udid":"6d9b9369-9691-9696-c599-669794c86ecc6b929e6c",
				"ip":"124.202.178.118",
				"place":"北京市.北京市",
				"active":"1"
			}
		],
		"teminal_number":"1"
	}
失败：
	{
		"error_code":"4",
		"error_msg":"服务器内部错误"
	}</code></pre>
	</div>
</template>
<script>
	import DocumentTitleBar from '../../../../components/documentTitleBar';
	import AuthorityErrorCode from '../../../../components/authorityErrorCode';
	import FrmRequestParamsTable from'../../../../components/frmRequestParamsTable';
import FrmReturnValueTableNew from '../../../../components/frmReturnValueTableNew';
import FrmErrorCodeTable from '../../../../components/frmErrorCodeTable';
	export default{
		components:{
			'document-title-bar':DocumentTitleBar,
			'authority-error-code':AuthorityErrorCode,
			'frm-Request-parameters':FrmRequestParamsTable,
			'frm-Return-Value-New':FrmReturnValueTableNew,
			'frm-Error-Code':FrmErrorCodeTable, 
		},
		data(){
			return{
				isPathData:['FRM API-v2','终端管理','获取全部终端'],
				frmRequestParams:[
					{"require":"是","name":"account_id","type":"int","msg":"当前账号id"},
					{"require":"是","name":"token","type":"string","msg":"当前账号登录后返回的token"},
					{"require":"是","name":"project_id","type":"int","msg":"项目id"},
					{"require":"是","name":"group_id","type":"int","msg":"要获取的终端组id"},
					{"require":"否","name":"page","type":"int","msg":"终端列表页索引，（注：每页100个终端），索引值从1开始"},
					{"require":"否","name":"sort","type":"string","msg":"排序方式（按姓名正序name_asc，按姓名倒序name_desc，）"},],
frmReturnValueNew:[
					{
						"Parameter":"error_code",
						"name":"string",
						"msg":"0 成功  1 失败",
						"rowspan":1,
						"colspan":1,
					},
					{
						"Parameter":"error_msg",
						"name":"string",
						"msg":"成功返回 success  失败返回 fail",
						"rowspan":1,
						"colspan":1,
					},
					{"Parameter":"teminal_number","name":"string","msg":"终端总个数","rowspan":1,"colspan":1},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"终端信息数组",
						"rowspan":10,
						"colspan":1,
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"terminal_id   string    终端id",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"terminal_name   string    终端名称",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"udid   string    终端唯一设备号",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"ability   string    1 正常 2禁用",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"ip   string    终端最后接入平台ip",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"platform   string   终端平台",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"visual_image   string    终端开机图片URL",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"sdk_version   string    SDK版本",
					},
					{
						"Parameter":"data",
						"name":"array",
						"msg":"active   string    1在线 2不在线",
					},
				],

frmErrorCode:[
					{"Statuscode":"1","errormessage":"fail","msg":"服务器繁忙"},
					{"Statuscode":"3003","errormessage":"group_id无效","msg":"终端组不存在"},
					{"Statuscode":"9001","errormessage":"token无效","msg":"token过期"},
				],
			}
		},
		watch:{

		},
		methods:{

		},
		mounted(){

		}
	}
</script>
<style lang="less" rel="stylesheet/less">
	@import '../../../../less/index.less';
	.sdk_initaial{
	}
</style>	



// WEBPACK FOOTER //
// src/views/documents/FRMAPIVTOW/Terminalmanagement/Acquisitionallterminals.vue